// components/screens/PaymentErrorScreen.tsx
import React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";

interface Props {
  navigation: NativeStackNavigationProp<RootStackParamList, "PaymentError">;
}

export default function PaymentErrorScreen({ navigation }: Props) {
  return (
    <View style={styles.container}>
      <Text style={styles.cross}>✗</Text>
      <Text style={styles.title}>Payment Failed</Text>
      <Text style={styles.subtitle}>Your payment could not be processed.</Text>
      <TouchableOpacity
        style={styles.button}
        onPress={() => navigation.replace("Profile")}
      >
        <Text style={styles.buttonText}>Return to Profile</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#112345",
    justifyContent: "center",
    alignItems: "center",
  },
  cross: {
    fontSize: 72,
    color: "#ff4444",
    marginBottom: 20,
  },
  title: {
    fontSize: 28,
    color: "#fff",
    fontWeight: "bold",
    marginBottom: 10,
  },
  subtitle: {
    fontSize: 16,
    color: "#aaa",
    marginBottom: 40,
  },
  button: {
    backgroundColor: "#00f0ff",
    paddingHorizontal: 32,
    paddingVertical: 16,
    borderRadius: 8,
  },
  buttonText: {
    color: "#000",
    fontSize: 16,
    fontWeight: "bold",
  },
});